import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ClipboardCheck, Moon, BarChart3 } from 'lucide-react';
export function ValueStackSection() {
  const stackItems = [{
    icon: <BookOpen className="w-5 h-5" data-id="element-307" />,
    title: 'Plantas Mexicanas para Dormir Profundo — Protocolo completo',
    type: 'Producto Principal',
    value: '$17 USD',
    isFree: false
  }, {
    icon: <ClipboardCheck className="w-5 h-5" data-id="element-308" />,
    title: 'La Lista CERO-ERROR del Mercado + Identificador Visual',
    type: 'Bono #1',
    value: '$22 USD',
    isFree: true
  }, {
    icon: <Moon className="w-5 h-5" data-id="element-309" />,
    title: 'Ritual 10 Min: Guión Nocturno Anti-Desvelo',
    type: 'Bono #2',
    value: '$22 USD',
    isFree: true
  }, {
    icon: <BarChart3 className="w-5 h-5" data-id="element-310" />,
    title: 'Tracker Sueño 7 Noches + Calculadora de Progreso',
    type: 'Bono #3',
    value: '$22 USD',
    isFree: true
  }];
  return <section className="py-12 md:py-20 px-4 bg-forest-800" data-id="element-311">
      <div className="max-w-4xl mx-auto" data-id="element-312">
        <div className="text-center mb-10 md:mb-16" data-id="element-313">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif font-bold text-gold-500 mb-4" data-id="element-314">
            RESUMEN DEL STACK
          </motion.h2>
          <p className="text-xl text-cream-200" data-id="element-315">Mirá lo que te llevás hoy:</p>
        </div>

        <div className="bg-forest-900 rounded-2xl border border-forest-600 shadow-2xl overflow-hidden mb-12" data-id="element-316">
          {/* Table Header (Desktop only) */}
          <div className="hidden md:flex bg-forest-700/50 p-4 border-b border-forest-600 text-sm font-bold text-cream-300 uppercase tracking-wider" data-id="element-317">
            <div className="w-1/4" data-id="element-318">LO QUE INCLUYE</div>
            <div className="w-1/2" data-id="element-319"></div>
            <div className="w-1/4 text-right" data-id="element-320">VALOR</div>
          </div>

          {/* Table Body */}
          <div className="divide-y divide-forest-700/50" data-id="element-321">
            {stackItems.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex flex-col md:flex-row items-start md:items-center p-5 md:p-6 gap-4 hover:bg-forest-800/50 transition-colors" data-id="element-322">
                <div className="w-full md:w-1/4 flex items-center gap-3" data-id="element-323">
                  <div className={`p-2 rounded-lg ${item.isFree ? 'bg-gold-500/10 text-gold-500' : 'bg-green-500/10 text-green-500'}`} data-id="element-324">
                    {item.icon}
                  </div>
                  <span className="font-bold text-cream-100 text-sm md:text-base" data-id="element-325">
                    {item.type === 'Producto Principal' ? '📗 ' : '🎁 '}
                    {item.type}
                  </span>
                </div>

                <div className="w-full md:w-1/2 text-cream-200 text-sm md:text-base" data-id="element-326">
                  {item.title}
                </div>

                <div className="w-full md:w-1/4 flex items-center justify-between md:justify-end gap-3" data-id="element-327">
                  <span className={`text-sm md:text-base ${item.isFree ? 'text-cream-300 line-through' : 'text-cream-100 font-bold'}`} data-id="element-328">
                    {item.value}
                  </span>
                  {item.isFree && <span className="bg-green-500 text-forest-900 text-xs font-bold px-2 py-1 rounded uppercase" data-id="element-329">
                      GRATIS
                    </span>}
                </div>
              </motion.div>)}
          </div>

          {/* Table Footer */}
          <div className="bg-forest-700/30 p-6 md:p-8 border-t-2 border-forest-600" data-id="element-330">
            <div className="flex justify-between items-center mb-4" data-id="element-331">
              <span className="text-cream-300 text-lg" data-id="element-332">Valor total real</span>
              <span className="text-cream-300 text-xl line-through" data-id="element-333">
                $83 USD
              </span>
            </div>
            <div className="flex justify-between items-center" data-id="element-334">
              <span className="text-gold-400 font-bold text-xl md:text-2xl" data-id="element-335">
                Hoy pagás
              </span>
              <span className="text-gold-500 font-bold text-3xl md:text-4xl font-serif" data-id="element-336">
                $17 USD
              </span>
            </div>
          </div>
        </div>

        {/* Closing Copy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6 text-center md:text-left text-lg text-cream-200 max-w-3xl mx-auto" data-id="element-337">
          <p data-id="element-338">
            Todo esto — el protocolo + los 3 bonos — por{' '}
            <span className="text-gold-400 font-bold" data-id="element-339">$17</span>.
          </p>
          <p data-id="element-340">
            No por <span className="line-through text-cream-400" data-id="element-341">$83</span>. No
            por <span className="line-through text-cream-400" data-id="element-342">$47</span>. No por{' '}
            <span className="line-through text-cream-400" data-id="element-343">$27</span>.<br data-id="element-344" />
            <span className="font-bold text-cream-100" data-id="element-345">
              Por diecisiete dólares.
            </span>
          </p>
          <p className="bg-forest-900/50 p-4 rounded-lg border border-forest-600" data-id="element-346">
            Y si en 7 días no dormís mejor — te devuelvo cada centavo. Sin
            preguntas. Sin formularios. Sin drama.
          </p>
          <p data-id="element-347">Pero hay algo que tenés que entender:</p>
          <p className="italic text-cream-300" data-id="element-348">
            Los bonos son parte de este lanzamiento. No van a estar aquí para
            siempre como parte del paquete a este precio. Cuando suba el precio
            del protocolo — los bonos se venden por separado.
          </p>
        </motion.div>
      </div>
    </section>;
}